import React from 'react';

type ElementInViewProps = {
  children: React.ReactNode;
};

const ElementInView = (props: ElementInViewProps) => {
  const { children } = props;
  const ref: React.MutableRefObject<any> = React.useRef();
  const [isVisible, setIsVisible] = React.useState<boolean>(false);
  React.useEffect(() => {
    const observer = new IntersectionObserver(([{ isIntersecting }]) => {
      if (isIntersecting && !isVisible) {
        observer.disconnect();
        setIsVisible(true);
      }
    });
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, []);
  return isVisible ? <>{children}</> : <div ref={ref} />;
};

export default ElementInView;
